const updates = [
  {
    date: '2026-07-31',
    tag: '新片上线',
    tagColor: 'bg-accent-500',
    title: '《星际迷航：新纪元》高清版已上线',
    desc: '年度科幻巨制正式登陆被窝网电影，4K超清画质，中英双语字幕。',
  },
  {
    date: '2026-07-30',
    tag: '剧集更新',
    tagColor: 'bg-primary-500',
    title: '《长安十二时辰》第二季全集同步上线',
    desc: '口碑古装悬疑剧回归，全集一次性放出，无需等待周更。',
  },
  {
    date: '2026-07-29',
    tag: '系统优化',
    tagColor: 'bg-secondary-500',
    title: '播放线路全面升级，新增三条备用CDN',
    desc: '进一步提升全国各地区播放流畅度，高峰时段不再卡顿。',
  },
  {
    date: '2026-07-28',
    tag: '专题上线',
    tagColor: 'bg-accent-500',
    title: '「夏日观影指南」专题页正式推出',
    desc: '精选50部适合夏日观看的清爽影片，涵盖喜剧、动画、青春类型。',
  },
  {
    date: '2026-07-27',
    tag: '电影上线',
    tagColor: 'bg-primary-500',
    title: '《深海历险》动画电影独家高清首发',
    desc: '国产动画年度力作，豆瓣评分8.7，亲子观影首选推荐。',
  },
  {
    date: '2026-07-26',
    tag: '资源更新',
    tagColor: 'bg-primary-500',
    title: '日漫秋季新番预告专题已更新',
    desc: '提前锁定十月新番信息，包含独家PV和声优阵容介绍。',
  },
  {
    date: '2026-07-25',
    tag: '功能升级',
    tagColor: 'bg-secondary-500',
    title: '移动端播放器全面适配深色模式',
    desc: '夜间观影更护眼，自动跟随系统主题切换明暗界面。',
  },
  {
    date: '2026-07-24',
    tag: '榜单发布',
    tagColor: 'bg-accent-500',
    title: '本周热播榜TOP20新鲜出炉',
    desc: '《江湖风云录》蝉联榜首，《星际迷航》新上榜即进前三。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            被窝网电影每日更新资讯，不错过任何精彩内容
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-0.5 bg-background-200 hidden sm:block"></div>
          <div className="space-y-5">
            {updates.map((item, i) => (
              <div key={i} className="relative flex gap-4 sm:gap-6">
                <div className="hidden sm:flex flex-col items-center flex-shrink-0 pt-1">
                  <span className={`w-2.5 h-2.5 rounded-full ${item.tagColor} relative z-10`}></span>
                </div>
                <div className="flex-1 bg-background-50 border border-background-200/70 rounded-xl p-4 md:p-5">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className={`px-2 py-0.5 text-xs font-medium text-background-50 ${item.tagColor} rounded whitespace-nowrap`}>
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-400">{item.date}</span>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1">{item.title}</h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}